import { Component, OnInit, Input, Optional } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ActivityCheckSuitabilityComponent } from '../activity-check-suitability/activity-check-suitability.component';
import {
  CheckSuitabilityDataObj,
  CorrespondenceDataObj,
  CheckstatusChangeObj,
  CheckInterviewSchDataObj,
  HrPanelInterviewObj,
} from '../../../shared/models/activity-dashboard-model';
import { ActivityCorrespondenceComponent } from '../activity-correspondence/activity-correspondence.component';
import { ActivityScheduleinterviewComponent } from '../activity-scheduleinterview/activity-scheduleinterview.component';
import { ActivityStatusChangeComponent } from '../activity-status-change/activity-status-change.component';
import { ActivityHRInterviewComponent } from '../activity-hrinterview/activity-hrinterview.component';
import { CoupledActivityComponent } from '../coupled-activity/coupled-activity.component';
import { SchedulerCandidate } from 'src/app/shared/models/schedulerAssociate';
import { ActivatedRoute } from '@angular/router';
@Component({
  selector: 'app-activity-dialog',
  templateUrl: './activity-dialog.component.html',
  styleUrls: ['./activity-dialog.component.scss'],
  standalone: false,
})
export class ActivityDialogComponent implements OnInit {
  @Input() editcheckSuitabilityDataObj: CheckSuitabilityDataObj;
  @Input() editcandidateApplicationIds: number[];
  @Input() editcheckCorrespondenceDataObj: CorrespondenceDataObj;
  @Input() editcheckInterviewDataObj: CheckInterviewSchDataObj;
  @Input() editcheckStatusChangeDataObj: CheckstatusChangeObj;
  @Input() editcheckHrPanelInterviewObj: HrPanelInterviewObj;

  @Input() coupledEditCheckSuitabilityDataObj1: CheckSuitabilityDataObj;
  @Input() coupledEditCheckSuitabilityDataObj2: CheckSuitabilityDataObj;

  @Input() coupledEditCheckCorrespondenceDataObj1: CorrespondenceDataObj;
  @Input() coupledEditCheckCorrespondenceDataObj2: CorrespondenceDataObj;

  @Input() coupledEditCheckInterviewDataObj1: CheckInterviewSchDataObj;
  @Input() coupledEditCheckInterviewDataObj2: CheckInterviewSchDataObj;

  @Input() coupledEditCheckStatusChangeDataObj1: CheckstatusChangeObj;
  @Input() coupledEditCheckStatusChangeDataObj2: CheckstatusChangeObj;

  @Input() coupledEditCheckHrPanelInterviewObj1: HrPanelInterviewObj;
  @Input() coupledEditCheckHrPanelInterviewObj2: HrPanelInterviewObj;

  @Input() onSuitability: boolean;
  @Input() onCorrespondence: boolean;
  @Input() onInterviewSchedule: boolean;
  @Input() onStatusChangeSchedule: boolean;
  @Input() onHrPanelInterview: boolean;

  @Input() onCoupledSuitability: boolean;
  @Input() onCoupledCorrespondence: boolean;
  @Input() onCoupledInterviewSchedule: boolean;
  @Input() onCoupledStatusChangeSchedule: boolean;
  @Input() onCoupledHrPanelInterview: boolean;

  @Input() ifCoupled: boolean;
  @Input() resetFlag: any;
  @Input() interviewFlag: boolean;
  @Input() candidateEmails: string[];
  @Input() selectedCandidate: SchedulerCandidate[];
  @Input() candidateApplicationIds: number[];
  @Input() activityMode: any;
  constructor(
    @Optional() public dialog: MatDialog,
    private route: ActivatedRoute,
    @Optional() private dialogref: MatDialogRef<ActivityCheckSuitabilityComponent>,
  ) {}

  ngOnInit() {
    console.log(Number(this.route.snapshot.paramMap.get('id')), '-----luffy');

    console.log('editeditcheckSuitabilityDataObj', this.editcheckSuitabilityDataObj);
    console.log('correspondance', this.editcheckCorrespondenceDataObj);
    console.log('interview', this.editcheckInterviewDataObj);
    console.log('status chnge', this.coupledEditCheckStatusChangeDataObj1);
    console.log('status chnge', this.coupledEditCheckStatusChangeDataObj2);
    console.log('edit candidate ids', this.editcandidateApplicationIds);
    console.log('coupled suitability', this.coupledEditCheckSuitabilityDataObj2);
    console.log(this.onSuitability);
    console.log(this.onCoupledSuitability);
    console.log(this.onStatusChangeSchedule);
    console.log(this.onCoupledStatusChangeSchedule);
    // console.log('activity dialog called ',this.editactivity
    console.log('dialog emails--', this.candidateEmails);
    //edit coupled
    if (this.ifCoupled) {
      console.log('inside ifCoupled');
      const dialogRef = this.dialog.open(CoupledActivityComponent, {
        width: '60%',
        maxHeight: '90vh',

        data: {
          checkSuitabilityDataObj: this.coupledEditCheckSuitabilityDataObj1,
          correspondenceDataObj: this.coupledEditCheckCorrespondenceDataObj1,
          checkInterviewSchDataObj: this.coupledEditCheckInterviewDataObj1,
          checkStatusChangeObj: this.coupledEditCheckStatusChangeDataObj1,
          checkHrPanelInterviewObj: this.coupledEditCheckHrPanelInterviewObj1,

          coupledcheckSuitabilityDataObj: this.coupledEditCheckSuitabilityDataObj2,
          coupledcorrespondenceDataObj: this.coupledEditCheckCorrespondenceDataObj2,
          coupledcheckInterviewSchDataObj: this.coupledEditCheckInterviewDataObj2,
          coupledcheckStatusChangeObj: this.coupledEditCheckStatusChangeDataObj2,
          coupledcheckHrPanelInterviewObj: this.coupledEditCheckHrPanelInterviewObj2,

          candidateEmails: this.candidateEmails,
          ifCoupled: true,

          onCoupledSuitability: this.onCoupledSuitability,
          onCoupledCorrespondence: this.onCoupledCorrespondence,
          onCoupledHrPanelInterview: this.onCoupledHrPanelInterview,
          onCoupledStatusChangeSchedule: this.onCoupledStatusChangeSchedule,
          onCoupledInterviewSchedule: this.onCoupledInterviewSchedule,

          onSuitability: this.onSuitability,
          onCorrespondence: this.onCorrespondence,
          onHrPanelInterview: this.onCoupledHrPanelInterview,
          onInterviewSchedule: this.onInterviewSchedule,
          onStatusChangeSchedule: this.onStatusChangeSchedule,

          selectedCandidate: this.selectedCandidate,

          interviewFlag: this.interviewFlag,
          editActivity: true,
          readFlag: this.activityMode == 'read' ? true : false,
        },
      });

      dialogRef.afterClosed().subscribe((_result) => {
        console.log(this.resetFlag);

        console.log('The dialog was closed');
      });
    }
    //edit couple ends
    if (this.editcheckSuitabilityDataObj !== undefined) {
      const dialogRef = this.dialog.open(ActivityCheckSuitabilityComponent, {
        width: '60%',
        maxHeight: '90vh',

        data: {
          checkSuitabilityDataObj: this.editcheckSuitabilityDataObj,
          editActivity: true,
          readFlag: this.activityMode == 'read' ? true : false,
          selectedCandidate: this.selectedCandidate,
        },
      });
      dialogRef.afterClosed().subscribe((_result) => {
        console.log(this.resetFlag);
        console.log('The dialog was closed');
      });
    }
    if (this.editcheckCorrespondenceDataObj !== undefined) {
      const dialogRef = this.dialog.open(ActivityCorrespondenceComponent, {
        width: '70%',
        maxHeight: '90vh',
        data: {
          correspondenceDataObj: this.editcheckCorrespondenceDataObj,
          editActivity: true,
          candidateEmails: this.candidateEmails,
          readFlag: this.activityMode == 'read' ? true : false,
        },
      });
      dialogRef.afterClosed().subscribe((_result) => {
        console.log(this.resetFlag);
        console.log('The dialog was closed--corresp');
      });
    }
    if (this.editcheckInterviewDataObj !== undefined) {
      const dialogRef = this.dialog.open(ActivityScheduleinterviewComponent, {
        width: '70%',
        maxHeight: '90vh',
        data: {
          checkInterviewSchDataObj: this.editcheckInterviewDataObj,
          editActivity: true,
          candidateEmails: this.candidateEmails,
          interviewFlag: true,
          readFlag: this.activityMode == 'read' ? true : false,
        },
      });
      dialogRef.afterClosed().subscribe((_result) => {
        console.log(this.resetFlag);
        console.log('The dialog was closed---interview');
      });
    }
    if (this.editcheckStatusChangeDataObj !== undefined) {
      const dialogRef = this.dialog.open(ActivityStatusChangeComponent, {
        width: '70%',
        maxHeight: '90vh',
        panelClass: 'paneltestClass',
        data: {
          checkStatusChangeObj: this.editcheckStatusChangeDataObj,
          editActivity: true,
          editcandidateApplicationIds: this.editcandidateApplicationIds,
          readFlag: this.activityMode == 'read' ? true : false,
          candidateId: Number(this.route.snapshot.paramMap.get('id')),
        },
      });
      dialogRef.afterClosed().subscribe((_result) => {
        console.log(this.resetFlag);
        console.log('The dialog was closed---statutschange');
      });
    }
    if (this.editcheckHrPanelInterviewObj !== undefined) {
      const dialogRef = this.dialog.open(ActivityHRInterviewComponent, {
        width: '70%',
        maxHeight: '90vh',
        panelClass: 'paneltestClass',
        data: {
          checkHrPanelInterviewObj: this.editcheckHrPanelInterviewObj,
          editActivity: true,
          readFlag: this.activityMode == 'read' ? true : false,
        },
      });
      dialogRef.afterClosed().subscribe((_result) => {
        console.log(this.resetFlag);
        console.log('The dialog was closed---statutschange');
      });
    }
  }
}
